export const licenseIsLoading = (license: { loading: boolean }) => license.loading;
export const isValidLicense = (license: { missing: boolean, status?: { valid: boolean }}) => license && !license.missing && (license.status && license.status.valid);
